import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import isEmpty from 'lodash/isEmpty';
import { useEffect } from 'react';
import { Icon } from '../Icon/Icon';
import { NoData } from '../NoData/NoData';
import { Spinner } from '../Spinner/Spinner';
import { Text } from '../Text/Text';
import { FlexContainer } from '../layout/FlexContainer';
export const DynamicContent = ({ data, isPending, error, renderContent, renderErrorContent, errorText, noData, loadingElement, disableEmptyCheck = false, onContentReady, }) => {
    const isDataDefined = data !== undefined;
    const isDataNotEmpty = disableEmptyCheck || !isEmpty(data);
    const hasData = isDataDefined && isDataNotEmpty;
    const isContentReady = !isPending && hasData;
    useEffect(() => {
        if (isContentReady) {
            onContentReady?.();
        }
    }, [isContentReady, onContentReady]);
    if (isPending) {
        if (loadingElement !== undefined)
            return _jsx(_Fragment, { children: loadingElement });
        return (_jsx(FlexContainer, { spacing: true, center: true, fullHeight: true, children: _jsx(Spinner, {}) }));
    }
    if (error) {
        const renderedErrorContent = renderErrorContent?.(error);
        if (renderedErrorContent) {
            return _jsx(_Fragment, { children: renderedErrorContent });
        }
        return (_jsxs(FlexContainer, { direction: 'column', center: true, fullHeight: true, children: [_jsx(Icon, { name: 'SearchOff' }), _jsx(Text, { children: errorText })] }));
    }
    const dataEmpty = !hasData;
    if (dataEmpty) {
        if (typeof noData === 'string')
            return _jsx(NoData, { text: noData });
        return _jsx(_Fragment, { children: noData });
    }
    const contentElement = renderContent(data);
    return _jsx(_Fragment, { children: contentElement });
};
